'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z' });

var CardMembership = function CardMembership(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

CardMembership = (0, _pure2.default)(CardMembership);
CardMembership.muiName = 'SvgIcon';

exports.default = CardMembership;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/CardMembership.js
// module id = 2232
// module chunks = 0